/* eslint-disable no-restricted-globals */
import _ from 'lodash'

import { env } from 'portal/lib/config/env-config.js'

/**
 * @type {import("@azure/msal-browser").Configuration}
 */
export const msalConfig = {
  auth: {
    authority: env.B2C_AUTHORITY + '/' + env.B2C_SIGNIN_POLICY,
    knownAuthorities: [env.B2C_AUTHORITY],
    clientId: env.CLIENT_ID,
    redirectUri: location.origin + '/signin-oidc',
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: location.origin + '/'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    claimsBasedCachingEnabled: true
  },
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 8000
    // loggerOptions: {
    //   logLevel: 1,
    //   piiLoggingEnabled: true,
    //   loggerCallback: (level, message) => {
    //     console.log(message)
    //   }
    // }
  }
}

export const passwordResetAuthority =
  env.B2C_AUTHORITY + '/' + env.B2C_RESET_PASSWORD_POLICY

export const authenticationParameters = {
  scopes: _.uniq(['openid', ...env.SCOPES.split(' ')])
}

export const apiURL = env.API_URL

export const correlationHeader = 'zametek-utility-trackingcontext'
